import {
  CardContent,
  CardHeader,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import {pink} from '@mui/material/colors';
import PropTypes from 'prop-types';
import React from 'react';
import {FEATURE_STATE} from '@app/constants/uploads.js';
import AreaIndicator from '@components/common/AreaIndicator';
import ChipAndLabel from '@components/common/ChipAndLabel.jsx';

const FeatureCardContent = ({featureData = {}, isPending = false}) => {
  const title =
    featureData?.state === FEATURE_STATE.ERROR
      ? 'Invalid feature'
      : featureData?.alternative_properties
        ? featureData.alternative_properties['pl:technique']
        : 'Simplified geometry';

  const subheader =
    featureData.state === FEATURE_STATE.ERROR
      ? 'This feature could not be imported due to an error'
      : 'This feature has been simplified and/or corrected';

  return (
    <>
      <CardHeader
        sx={{py: 1}}
        title={
          isPending ? (
            <Skeleton animation="wave" width="80%" style={{marginBottom: 6}} />
          ) : (
            title
          )
        }
        titleTypographyProps={{variant: 'subtitle1'}}
        subheaderTypographyProps={{variant: 'body2'}}
        subheader={
          isPending ? <Skeleton animation="wave" width="40%" /> : subheader
        }
      />
      <CardContent>
        {isPending ? (
          <>
            <Skeleton
              animation="wave"
              height={20}
              width="25%"
              style={{marginBottom: 8}}
            />
            <Skeleton
              animation="wave"
              height={20}
              width="60%"
              style={{marginBottom: 16}}
            />
            <Skeleton animation="wave" height={22} style={{marginBottom: 8}} />
            <Skeleton animation="wave" height={22} />
          </>
        ) : featureData.state === FEATURE_STATE.ERROR ? (
          featureData.errors?.map(e => (
            <Typography key={e} variant="body2" sx={{mt: 1}}>
              {e}
            </Typography>
          ))
        ) : (
          <>
            <Typography variant="body2" sx={{marginBottom: 1}}>
              Reason:
            </Typography>
            <Typography variant="body2" sx={{marginBottom: 2}}>
              {!!featureData?.alternative_properties &&
                featureData.alternative_properties['pl:reason_detail']}
            </Typography>
            <Stack
              direction="column"
              sx={{
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 1,
              }}
            >
              <ChipAndLabel color="primary">
                Original
                {!!featureData.properties &&
                  !!featureData.properties['pl:area'] && (
                    <>
                      {' '}
                      area:{' '}
                      <AreaIndicator
                        squareMeters={featureData.properties['pl:area']}
                      />
                    </>
                  )}
              </ChipAndLabel>
              <ChipAndLabel color={pink}>
                Simplified
                {!!featureData.alternative_properties &&
                  !!featureData.alternative_properties['pl:area'] && (
                    <>
                      {' '}
                      area:{' '}
                      <AreaIndicator
                        squareMeters={
                          featureData.alternative_properties['pl:area']
                        }
                      />
                    </>
                  )}
              </ChipAndLabel>
            </Stack>
          </>
        )}
      </CardContent>
    </>
  );
};

FeatureCardContent.propTypes = {
  featureData: PropTypes.object,
  isPending: PropTypes.bool,
};

export default FeatureCardContent;
